import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Beneficiary, CallDisposition } from '@/models';

export interface CallState {
  activeBeneficiary: Beneficiary | null;
  callStartedAt: number | null;
  connected: boolean;
  draftDisposition: CallDisposition | null;
  draftNotes: string;
}

const initialState: CallState = {
  activeBeneficiary: null,
  callStartedAt: null,
  connected: false,
  draftDisposition: null,
  draftNotes: '',
};

const callSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    startCall(state, action: PayloadAction<Beneficiary>) {
      state.activeBeneficiary = action.payload;
      state.callStartedAt = Date.now();
      state.connected = true;
      state.draftDisposition = null;
      state.draftNotes = '';
    },
    endCall(state) {
      state.connected = false;
      state.callStartedAt = null;
    },
    setDraftDisposition(state, action: PayloadAction<CallDisposition>) {
      state.draftDisposition = action.payload;
    },
    setDraftNotes(state, action: PayloadAction<string>) {
      state.draftNotes = action.payload;
    },
    clearCall() {
      return initialState;
    },
  },
});

export const { startCall, endCall, setDraftDisposition, setDraftNotes, clearCall } = callSlice.actions;
export default callSlice.reducer;
